import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, image, type = 'website' }) => {
  const location = useLocation();
  const baseUrl = 'https://nho.naivang.com';
  const url = `${baseUrl}${location.pathname}`;
  const defaultTitle = 'NHO - Nền tảng chia sẻ đồ không dùng đến';
  const defaultDescription = 'Nền tảng kết nối những món đồ không dùng đến với những người cần chúng. Chia sẻ yêu thương, giảm lãng phí.';
  const defaultImage = `${baseUrl}/og-image.jpg`;

  useEffect(() => {
    // Update title
    document.title = title ? `${title} | NHO` : defaultTitle;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || defaultDescription);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description || defaultDescription;
      document.head.appendChild(meta);
    }

    // Update or create Open Graph tags
    const updateOrCreateMeta = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    updateOrCreateMeta('og:title', title || defaultTitle);
    updateOrCreateMeta('og:description', description || defaultDescription);
    updateOrCreateMeta('og:image', image || defaultImage);
    updateOrCreateMeta('og:url', url);
    updateOrCreateMeta('og:type', type);
    updateOrCreateMeta('og:site_name', 'NHO');

    // Update or create Twitter Card tags
    updateOrCreateMeta('twitter:card', 'summary_large_image');
    updateOrCreateMeta('twitter:title', title || defaultTitle);
    updateOrCreateMeta('twitter:description', description || defaultDescription);
    updateOrCreateMeta('twitter:image', image || defaultImage);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', url);
      document.head.appendChild(canonical);
    }
  }, [title, description, image, type, url, defaultTitle, defaultDescription, defaultImage]);

  return null;
};

export default SEO;

